<template>
  <div class="o-page__content u-pt-small">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-12">
          <h1 class="u-h3">Report Summary</h1>
          <div style="display: inline-block; float: right; margin-top: -40px">
            <el-button
              icon="el-icon-document"
              class="u-mr-small"
              type="success"
              @click="doExport()"
              >Export</el-button
            >
          </div>

          <div class="row">
            <div class="col-12 col-xl-12">
              <div class="custom_toolbar u-mt-medium">
                <Select2
                  v-if="role == 1"
                  class="c-input"
                  v-model="params.region"
                  :options="regions"
                  :settings="{ width: '100%', placeholder: 'All Region' }"
                  @change="myChangeEvent($event)"
                />
                <Select2
                  v-if="role != 3"
                  class="c-input"
                  v-model="params.branch"
                  :options="branches"
                  :settings="{ width: '100%', placeholder: 'All Branch' }"
                  @change="myChangeEvent2($event)"
                />
                <Select2
                  v-if="role != 3"
                  class="c-input"
                  v-model="params.outlet"
                  :options="outlets"
                  :settings="{ width: '100%', placeholder: 'All Outlet' }"
                  @change="myChangeEvent3($event)"
                />
              </div>
            </div>
          </div>
          <div class="custom_toolbar">
            <select
              v-model="params.average"
              v-on:change="fetch"
              class="c-input"
              style="max-width: 200px"
            >
              <option value="">Semua Nilai</option>
              <option value="positif">Positif</option>
              <option value="negative">Negatif</option>
            </select>
            <select
              v-model="params.status"
              v-on:change="fetch"
              class="c-input"
              style="max-width: 200px"
            >
              <option value="">Semua Status</option>
              <!-- <option value="on-progress">On Progress</option>
              <option value="done">Selesai</option>
              <option value="new">Baru</option> -->
              <template v-for="stat in status_option">
                <option :key="stat.value" :value="stat.filter">
                  {{ stat.text }}
                </option>
              </template>
            </select>
            <input
              type="text"
              placeholder="Pencarian objek penilaian..."
              class="c-input"
              v-model="params.q"
              v-on:keyup="fetch"
            />

            <!-- <Select2 class="c-input" v-model="params.region" :options="regions" :settings="{ width: '100%', placeholder: 'All Region' }" @change="myChangeEvent($event)" @select="mySelectEvent($event)"/> -->
            <el-date-picker
              style="width: 100%"
              v-model="daterange"
              type="daterange"
              format="dd MMM yyyy"
              value-format="yyyy-MM-dd"
              start-placeholder="Start"
              @change="fetch"
              :picker-options="datePickerOptions"
              end-placeholder="End"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="row u-mt-medium" v-if="employee">
        <div class="col-12">
          <el-button size="small" icon="el-icon-back" @click="$router.go(-1)"
            >Back</el-button
          >
          <article class="c-stage u-mt-small">
            <div class="c-stage__header o-media u-justify-start">
              <div
                class="c-stage__icon o-media__img"
                style="width: 60px; height: 60px; background-size: cover"
                v-bind:style="{
                  'background-image': 'url(' + employee.image + ')',
                  backgroundPosition: 'center',
                }"
              ></div>
              <div class="c-stage__header-title o-media__body">
                <h6 class="u-mb-zero">{{ employee.name.toUpperCase() }}</h6>
                <p class="u-text-xsmall u-text-mute">
                  {{ employee.outlet_name }} | {{ employee.position_name }}
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>
      <div class="row u-mt-medium">
        <div class="col-12">
          <vue-good-table
            v-loading="loading"
            :columns="columns"
            :rows="rows"
            :select-options="{
              enabled: true,
              selectOnCheckboxOnly: true,
              disableSelectInfo: true,
            }"
            :pagination-options="{
              enabled: true,
            }"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'average_value'">
                <el-rate
                  :value="parseFloat(props.row.average_value) / 20"
                  disabled
                  show-score
                  text-color="#ff9900"
                  score-template="{value} star"
                >
                </el-rate>
              </span>

              <span v-else-if="props.column.field == 'region_name'">
                {{ props.row.region_name | uppercase }}
              </span>

              <span v-else-if="props.column.field == 'branch_name'">
                {{ props.row.branch_name | uppercase }}
              </span>

              <span v-else-if="props.column.field == 'outlet_name'">
                {{ props.row.outlet_name | uppercase }}
              </span>

              <span v-else-if="props.column.field == 'outlet_code'">
                {{ props.row.outlet_code }}
              </span>

              <span v-else-if="props.column.field == 'phone'">
                {{ props.row.phone }}
              </span>

              <span v-else-if="props.column.field == 'name'">
                {{ props.row.name }}
              </span>

              <span v-else-if="props.column.field == 'created_at'">
                {{ props.row.created_at }}
              </span>

              <span v-else-if="props.column.field == 'rating'">
                <div v-if="props.row.rating">
                  <ul style="liststyletype: circle; marginleft: 1em">
                    <li v-for="(item, idx) in props.row.rating" :key="idx">
                      <div v-if="item.type == 'STAR'">
                        {{ item.aspect_name }} : {{ item.rate }}
                        {{ jsonParse(item.suggestions) }}
                      </div>
                      <div v-else>{{ item.aspect_name }}: {{ item.note }}</div>
                    </li>
                  </ul>
                </div>
              </span>
              <span v-else-if="props.column.field == 'object'">
                {{ props.row.object.name }}
              </span>

              <span v-else-if="props.column.field == 'link_attachment'">
                <el-button
                  v-if="props.row.link_attachment == null"
                  disabled
                  size="mini"
                  type="success"
                  icon="el-icon-link"
                ></el-button>

                <a v-else :href="props.row.link_attachment" target="_blank">
                  <el-button
                    size="mini"
                    type="success"
                    icon="el-icon-link"
                  ></el-button>
                </a>

                <el-button
                  @click="dialogReportDetailLink(props.row)"
                  style="margin-left: 0.5em"
                  v-if="props.row.link_attachment != null"
                  size="mini"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                  :disabled="props.row.status == 2"
                ></el-button>

                <!-- Dialog edit link -->
                <el-dialog
                  title="Update Link"
                  :visible.sync="dialogVisible"
                  width="40%"
                  :close-on-press-escape="false"
                  :close-on-click-modal="false"
                  :show-close="false"
                >
                  <el-form :model="form">
                    <el-form-item label="Link file berita acara">
                      <el-input v-model="link_attachment" @change="isURLValid">
                      </el-input>
                    </el-form-item>
                  </el-form>
                  <span slot="footer" class="dialog-footer">
                    <el-button
                      @click="
                        dialogVisible = false;
                        isValid = false;
                      "
                      >Cancel</el-button
                    >
                    <el-button
                      type="primary"
                      @click="updateReportDetail()"
                      :disabled="!isValid"
                      :loading="false"
                      >Update</el-button
                    >
                  </span>
                </el-dialog>
              </span>

              <span v-else-if="props.column.field == 'desc'">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="Tidak ada komentar"
                  v-model="props.row.desc"
                  readonly
                >
                </el-input>
                <el-button
                  @click="dialogReportDetailDesc(props.row)"
                  style="margin-left: 0.5em; margin-top: 0.5em"
                  size="mini"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                ></el-button>

                <!-- Dialog edit desc -->
                <el-dialog
                  title="Update Deskripsi"
                  :visible.sync="dialogVisibleDesc"
                  width="40%"
                  :close-on-press-escape="false"
                  :close-on-click-modal="false"
                  :show-close="false"
                >
                  <el-form :model="form">
                    <el-form-item label="Deskripsi">
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4 }"
                        placeholder="Tidak ada komentar"
                        v-model="desc"
                      >
                      </el-input>
                    </el-form-item>
                  </el-form>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisibleDesc = false"
                      >Cancel</el-button
                    >
                    <el-button
                      type="primary"
                      @click="updateReportDetail()"
                      :loading="false"
                      >Update</el-button
                    >
                  </span>
                </el-dialog>
              </span>

              <span v-else-if="props.column.field == 'desc_sw'">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  placeholder="Tidak ada notes"
                  v-model="props.row.desc_sw"
                  readonly
                >
                </el-input>
                <el-button
                  @click="dialogReportDetailDescSw(props.row)"
                  style="margin-left: 0.5em; margin-top: 0.5em"
                  size="mini"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                ></el-button>

                <!-- Dialog edit desc -->
                <el-dialog
                  title="Update Deskripsi"
                  :visible.sync="dialogVisibleDescSW"
                  width="40%"
                  :close-on-press-escape="false"
                  :close-on-click-modal="false"
                  :show-close="false"
                >
                  <el-form :model="form">
                    <el-form-item label="Deskripsi">
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4 }"
                        placeholder="Tidak ada komentar"
                        v-model="desc_sw"
                      >
                      </el-input>
                    </el-form-item>
                  </el-form>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisibleDescSW = false"
                      >Cancel</el-button
                    >
                    <el-button
                      type="primary"
                      @click="updateReportDetail()"
                      :loading="false"
                      >Update</el-button
                    >
                  </span>
                </el-dialog>
              </span>

              <span v-else-if="props.column.field == 'ba_updated_at'">
                {{ props.row.ba_updated_at }}
              </span>

              <span v-else-if="props.column.field == 'status'">
                <select
                  v-model="props.row.status"
                  class="c-input"
                  @change="setStatus($event, props.row.originalIndex)"
                >
                  <template v-for="stat in status_option">
                    <option
                      v-if="
                        filterStatusByCurrentStatus(
                          props.row.status,
                          stat.value
                        )
                      "
                      :key="stat.value"
                      :value="stat.value"
                    >
                      {{ stat.text }}
                    </option>
                  </template>
                </select>
              </span>

              <!-- Dialog link BA -->
              <el-dialog
                title="Berita Acara"
                :visible.sync="dialogFormVisible"
                width="40%"
                close-on-press-escape
              >
                <el-form :model="form">
                  <el-form-item label="Link file berita acara">
                    <el-input v-model="link_attachment" @change="isURLValid">
                    </el-input>
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="cancel">Cancel</el-button>
                  <el-button
                    type="primary"
                    :disabled="!isValid"
                    @click="setStatusDone"
                    :loading="false"
                    >Submit</el-button
                  >
                </span>
              </el-dialog>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import api from "@/api/ratings";
import regions from "@/api/regions";
import branches from "@/api/branches";
import outlets from "@/api/outlets";
import outlet from "@/api/outlets";
import moment from "moment";
import { mapActions } from "vuex";
import axios from "axios";
import Select2 from "v-select2-component";

export default {
  components: {
    "vue-good-table": VueGoodTable,
    Select2,
  },
  data() {
    return {
      selected_row: null,
      role: localStorage.getItem("user_role_id"),
      relation_code: localStorage.getItem("relation_code"),
      dialogVisible: false,
      report_name: "",
      dialogVisibleDesc: false,
      dialogVisibleDescSW: false,
      dialogFormVisible: false,
      link_attachment: "",
      desc: "",
      desc_sw: "",
      status: null,
      index_status: null,
      form: {
        link_attachment: "",
      },
      regex:
        /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi,
      isValid: false,
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      daterange: [],
      columns: [
        {
          label: "Tanggal",
          field: "created_at",
        },
        {
          label: "Region",
          field: "region_name",
        },
        {
          label: "Branch",
          field: "branch_name",
        },
        {
          label: "Outlet",
          field: "outlet_name",
        },
        {
          label: "Kode Outlet",
          field: "outlet_code",
        },

        {
          label: "Nama Penilai",
          field: "name",
        },
        {
          label: "Telepon",
          field: "phone",
        },
        {
          label: "Nilai Rata-rata",
          field: "average_value",
        },
        {
          label: "Object Penilaian",
          field: "object",
        },
        {
          label: "Penilaian",
          field: "rating",
          width: "500px",
        },
        {
          label: "Link Berita Acara",
          field: "link_attachment",
        },
        // {
        //   label: "Comment",
        //   field: "desc",
        //   width: "300px",
        // },
        // {
        //   label: "Notes SMW",
        //   field: "desc_sw",
        //   width: "300px",
        // },
        {
          label: "SLA",
          field: "ba_updated_at",
        },
        {
          label: "Tindak Lanjut",
          field: "status",
          width: "150px",
        },
      ],
      rows: [],
      loading: false,
      employee: null,
      params: {
        q: "",
        status: "",
        average: "",
        position: "",
        region:
          localStorage.getItem("user_role_id") == 2
            ? localStorage.getItem("relation_code")
            : "",
        outlet:
          localStorage.getItem("user_role_id") == 3
            ? localStorage.getItem("relation_code")
            : "",
        branch: "",
        facility: "",
        code: "",
      },
      status_option: [],
      statuses: [
        {
          rule: "0,1",
          role: "1,2,3",
          value: 0,
          filter: "new",
          text: "Baru",
        },
        {
          rule: "1,3,4",
          role: "1,2,3",
          value: 1,
          filter: "on-progress",
          text: "On Progress",
        },
        {
          rule: "2",
          role: "1",
          value: 2,
          filter: "done",
          text: "Selesai",
        },
        {
          rule: "1,2,3",
          role: "1,2,3",
          value: 3,
          filter: "request-ba",
          text: "Request BA",
        },
        {
          rule: "1,4,5",
          role: "1,2,3",
          value: 4,
          filter: "request-na",
          text: "Request N.A",
        },
        {
          rule: "5",
          role: "1",
          value: 5,
          filter: "done-na",
          text: "Selesai N.A",
        },
      ],
      regions: [],
      branches: [],
      outlets: [],
      outlet_code: "",
    };
  },
  filters: {
    uppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  mounted() {
    let end = this.$route.query.end ? this.$route.query.end : new Date();
    var start = this.$route.query.start
      ? this.$route.query.start
      : moment(start).subtract(7, "days")._d;

    // append desc column
    if (this.role == 1) {
      this.columns.splice(11, 0, {
        label: "Comment",
        field: "desc",
        width: "300px",
      });
    }

    if (this.role == 2) {
      this.columns.splice(12, 0, {
        label: "Notes SMW",
        field: "desc_sw",
        width: "300px",
      });
    }

    // end = new Date(end)
    this.daterange = [start, end];

    this.params.region = this.$route.query.region
      ? this.$route.query.region
      : "";
    this.params.outlet = this.$route.query.outlet
      ? this.$route.query.outlet
      : "";
    this.params.branch = this.$route.query.branch
      ? this.$route.query.branch
      : "";

    if (this.params.region) {
      this.fetchBranches();
    }
    if (this.params.region) {
      this.fetchOutlets();
    }

    this.fetch();
    if (this.role == 1) {
      this.fetchRegions();
    }
    if (this.role == 2) {
      this.fetchBranches();
    }

    this.fetch();
    // this.fetchEmployees()
  },
  methods: {
    filterStatusByRole(role) {
      this.status_option = this.statuses.filter((status) =>
        status.role.includes(role)
      );
    },
    filterStatusByCurrentStatus(current_status, current_option) {
      for (const status of this.status_option) {
        if (current_status == status.value) {
          if (status.rule.includes(current_option)) {
            return true;
          }
        }
      }
      return false;
    },
    dialogReportDetailLink(data) {
      console.log(data);
      this.selected_row = data;
      this.link_attachment = data.link_attachment;
      this.desc = data.desc;
      this.dialogVisible = true;
    },
    dialogReportDetailDesc(data) {
      this.selected_row = data;
      this.link_attachment = data.link_attachment;
      this.desc = data.desc;
      this.dialogVisibleDesc = true;
    },
    dialogReportDetailDescSw(data) {
      this.selected_row = data;
      this.link_attachment = data.link_attachment;
      this.desc = data.desc;
      this.desc_sw = data.desc_sw;
      this.dialogVisibleDescSW = true;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    jsonParse(data) {
      if (data) {
        var string = "(";
        var datax = JSON.parse(data);
        datax.forEach((element, idx) => {
          string += element;
          if (idx != datax.length - 1) {
            string += ", ";
          }
        });
        string += ")";
        return string;
      } else {
        return "";
      }
    },
    dateField(rowObj) {
      return moment(rowObj.created_at).format("dddd, DD MMMM YYYY / H:mm");
    },
    ...mapActions(["logout"]),
    fetchEmployees() {
      var self = this;
      outlet
        .getOne(this.$route.params.code)
        .then(function (response) {
          self.employee = response.data.data;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    fetch() {
      this.filterStatusByRole(this.role);

      this.params.region = this.$route.query.region
        ? this.$route.query.region
        : "";

      if (this.params.region) this.outlet_code = this.params.region;

      this.params.branch = this.$route.query.branch
        ? this.$route.query.branch
        : "";

      if (this.params.branch) this.outlet_code += this.params.branch;

      this.params.outlet = this.$route.query.outlet
        ? this.$route.query.outlet
        : "";

      if (this.params.outlet) {
        this.outlet_code = this.params.outlet;
      } else {
        this.outlet_code = this.relation_code;
      }

      if (this.params.region) {
        this.fetchBranches();
      }
      if (this.params.region) {
        this.fetchOutlets();
      }

      this.loading = true;
      var self = this;
      this.rows = [];
      axios
        .get(
          "https://api-dash.bniservicerating.com/v1/rating/rating-visitor?outlet_code=" +
            this.outlet_code +
            "&user_role_id=" +
            this.role +
            "&relation_code=" +
            this.relation_code +
            "&startdate=" +
            moment(this.daterange[0]).format("YYYY-MM-DD") +
            "&enddate=" +
            moment(this.daterange[1]).format("YYYY-MM-DD") +
            "&average=" +
            this.params.average +
            "&status=" +
            this.params.status +
            "&name=" +
            this.params.q,
          {
            headers: {
              "x-api-key": "DBrbsrGFyoDFGI8XS1lDUhhL1W0XfkDmpnfAcrt",
              "x-access-token": localStorage.getItem("accessToken"),
            },
          }
        )
        // api.getDetail(this.$route.params.code, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'))
        .then(function (response) {
          if (response.data.data.length > 0) {
            self.rows = response.data.data;
            // self.totalRecords = 100
            self.loading = false;
          } else {
            self.loading = false;
          }
        })
        .catch(function (error) {
          console.log(error);
          if (error.response != undefined && error.response.status == 403) {
            self.logout();
          }
        });
    },
    isURLValid() {
      // this.isValid = this.regex.test(this.link_attachment);
      var expression =
        /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
      var regex = new RegExp(expression);
      if (this.link_attachment.match(regex)) {
        this.isValid = true;
      } else {
        this.isValid = false;
      }
      console.log(this.isValid);
    },

    setStatusDone() {
      console.log(this.isValid);

      let data = {
        status: this.status,
        link_attachment: this.link_attachment,
      };

      if (!this.isValid) {
        this.$message({
          message: "Url tidak valid",
          type: "error",
        });
        return;
      }

      this.loading = true;
      var self = this;
      axios
        .put(
          "https://api-dash.bniservicerating.com/v1/rating/update/" +
            this.rows[this.index_status].id,
          data,
          {
            headers: {
              "x-api-key": "DBrbsrGFyoDFGI8XS1lDUhhL1W0XfkDmpnfAcrt",
              "x-access-token": localStorage.getItem("accessToken"),
            },
          }
        )
        .then(function (response) {
          self.$message({
            message: "Success",
            type: "success",
          });
          self.fetch();
          self.loading = false;
          self.dialogFormVisible = false;
          self.status = null;
        })
        .catch(function (error) {
          if (error.response.status == 403) {
            self.logout();
            return;
          }
          self.dialogFormVisible = false;
          self.status = null;
        });
    },

    updateReportDetail() {
      console.log(this.selected_row);
      this.loading = true;

      let data = {
        status: this.selected_row.status,
        link_attachment: this.link_attachment,
        desc: this.desc,
        desc_sw: this.desc_sw,
      };

      var self = this;
      axios
        .put(
          "https://api-dash.bniservicerating.com/v1/rating/update/" +
            this.selected_row.id,
          data,
          {
            headers: {
              "x-api-key": "DBrbsrGFyoDFGI8XS1lDUhhL1W0XfkDmpnfAcrt",
              "x-access-token": localStorage.getItem("accessToken"),
            },
          }
        )
        .then(function (response) {
          self.$message({
            message: "Success",
            type: "success",
          });
          self.fetch();
          self.loading = false;
          self.dialogVisible = false;
          self.dialogVisibleDesc = false;
          self.dialogVisibleDescSW = false;
          self.isValid = false;
          self.selected_row = null;
        })
        .catch(function (error) {
          if (error.response.status == 403) {
            self.logout();
            return;
          }
          self.$message({
            message: error.response.data.message,
            type: "error",
          });
          self.dialogVisible = false;
          self.dialogVisibleDesc = false;
          self.dialogVisibleDescSW = false;
          self.loading = false;
          self.isValid = false;
          self.selected_row = null;
        });
    },

    setStatus(event, index) {
      if (event.target.value == 3 && this.status == null) {
        this.status = event.target.value;
        this.index_status = index;
        this.dialogFormVisible = true;
        return;
      }

      this.loading = true;
      var self = this;
      axios
        .put(
          "https://api-dash.bniservicerating.com/v1/rating/update/" +
            this.rows[index].id,
          {
            status: event.target.value,
          },
          {
            headers: {
              "x-api-key": "DBrbsrGFyoDFGI8XS1lDUhhL1W0XfkDmpnfAcrt",
              "x-access-token": localStorage.getItem("accessToken"),
            },
          }
        )
        .then(function (response) {
          self.$message({
            message: "Success",
            type: "success",
          });
          self.loading = false;
          self.status = null;
        })
        .catch(function (error) {
          console.log(error.response);
          if (error.response.status == 403) {
            self.logout();
            return;
          }
          self.$message({
            message: error.response.data.message,
            type: "error",
          });
          self.loading = false;
          self.status = null;
        });
    },

    cancel() {
      this.status = null;
      this.dialogFormVisible = false;
      this.fetch();
    },

    fetchRegions() {
      this.loading = true;
      var self = this;
      regions
        .getAll(this.relation_code)
        .then(function (response) {
          //
          var regionsx = [
            {
              id: 999999,
              text: "All Region",
            },
          ];
          response.data.data.forEach((element) => {
            regionsx.push({
              id: element.code,
              text: element.name,
            });
          });
          self.regions = regionsx;
          self.loading = false;
          // console.log(self.regions)
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    fetchBranches() {
      var self = this;

      let region = this.params.region;
      if (!region) region = this.relation_code;

      branches
        .getAll(region, this.relation_code)
        .then(function (response) {
          //
          var regionsx = [
            {
              id: 999999,
              text: "All Branches",
            },
          ];
          response.data.data.forEach((element) => {
            regionsx.push({
              id: element.code,
              text: element.name,
            });
          });
          self.branches = regionsx;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    fetchOutlets() {
      var self = this;
      let region = this.params.region;
      if (!region) region = this.relation_code;

      outlets
        .getAll(region, this.params.branch, this.relation_code)
        .then(function (response) {
          //
          var regionsx = [
            {
              id: 999999,
              text: "All Outlets",
            },
          ];
          response.data.data.forEach((element) => {
            regionsx.push({
              id: element.code,
              text: element.name,
            });
          });
          self.outlets = regionsx;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    myChangeEvent(val) {
      this.params.region = val;
      this.params.branch = "";
      this.$router.replace({
        query: { region: val },
      });
      this.fetchBranches();
      this.fetch();
      this.rowsFacility = [];
    },
    myChangeEvent2(val) {
      this.params.branch = val;
      this.params.outlet = "";
      this.$router.replace({
        query: {
          region: this.params.region,
          branch: val,
          start: moment(this.daterange[0]).format("YYYY-MM-DD"),
          end: moment(this.daterange[1]).format("YYYY-MM-DD"),
        },
      });
      this.fetchOutlets();
      this.fetch();
      this.rowsFacility = [];
    },
    myChangeEvent3(val) {
      this.params.outlet = val;
      this.$router.replace({
        query: {
          region: this.params.region,
          branch: this.params.branch,
          outlet: val,
          start: moment(this.daterange[0]).format("YYYY-MM-DD"),
          end: moment(this.daterange[1]).format("YYYY-MM-DD"),
        },
      });
      this.fetch();
    },
    myChangeEvent4(val) {
      this.params.position = val;
      this.$router.replace({
        query: {
          region: this.params.region,
          branch: this.params.branch,
          outlet: this.params.outlet,
          position: val,
          start: moment(this.daterange[0]).format("YYYY-MM-DD"),
          end: moment(this.daterange[1]).format("YYYY-MM-DD"),
        },
      });
      this.fetch();
    },
    search() {
      this.fetch();
    },
    doExport() {
      this.loading = true;
      var self = this;
      axios
        .get(
          "https://api-dash.bniservicerating.com/v1/rating/export-excel?startdate=" +
            moment(this.daterange[0]).format("YYYY-MM-DD") +
            "&enddate=" +
            moment(this.daterange[1]).format("YYYY-MM-DD") +
            "&outlet_code=" +
            this.params.outlet +
            "&branch_code=" +
            this.params.branch +
            "&region_code=" +
            this.params.region +
            "&user_role_id=" +
            this.role +
            "&relation_code=" +
            this.relation_code,
          {
            headers: {
              "x-api-key": "DBrbsrGFyoDFGI8XS1lDUhhL1W0XfkDmpnfAcrt",
              "x-access-token": localStorage.getItem("accessToken"),
              "Content-Disposition": "attachment; filename=template.xlsx",
              "Content-Type":
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            },
            responseType: "arraybuffer",
          }
        )
        // api.getRegion(this.params.region, this.params.branch, this.params.outlet, moment(this.daterange[0]).format('YYYY-MM-DD'), moment(this.daterange[1]).format('YYYY-MM-DD'), '')
        .then(function (response) {
          if (response.data) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "report.xlsx");
            document.body.appendChild(link);
            link.click();

            self.loading = false;
          } else {
            self.loading = false;
          }
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.custom_toolbar {
  display: flex;
  div {
    margin-right: 10px;
  }
}
</style>
